/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { reset } from 'redux-form';
import { getChosenCommentAction, sendCommentAction, setChosenCommentAction } from './actions';
import { getIsModalShownSelector, getIsFormSendingSelector, getIsChosenCommentLoadingSelector } from './selectors';
import { FORM_NAME } from './constants';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import { useInjectSaga } from '../../utils/injectSaga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import saga from './saga';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { ChosenCommentForm } from './components/chosen-comment-form';
import closeModal from '../../utils/closeModal';

const ChosenCommentModalWrapper = ({
	onGetChosenComment,
	isModalShown,
	onSendComment,
	onResetForm,
	isFormSending,
	onSetChosenComment,
	isChosenCommentLoading,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'chosenCommentModalSaga', saga });
	useInjectReducer({ key: 'chosenCommentModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		if (isModalShown) {
			onGetChosenComment(query.get('id'));
		}
	}, [isModalShown]);

	const handleModalCancel = () => {
		query.set('modal', 'reqs_details');
		onResetForm(FORM_NAME);
		onSetChosenComment(null);
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);
		onResetForm(FORM_NAME);
		onSetChosenComment(null);
		history.push(`${pathname}?${query}`);
	};

	const handleFormSubmit = async () => {
		onSendComment({
			redirect: handleModalCancel,
			id: query.get('id'),
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Изменить примечание"
			modalContent={<ChosenCommentForm />}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'chosen_comment' }]}
			footerButtons={
				<ModalFooterButtons
					rightButtons={[
						{
							onClick: handleFormSubmit,
							text: 'Сохранить',
							color: 'success',
							loading: isFormSending,
							disabled: isFormSending || isChosenCommentLoading,
						},
						{
							onClick: handleModalCancel,
							text: 'Закрыть',
							color: 'secondary',
							disabled: isFormSending,
						},
					]}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isModalShown: getIsModalShownSelector(),
	isFormSending: getIsFormSendingSelector(),
	isChosenCommentLoading: getIsChosenCommentLoadingSelector(),
});

const mapDispatchToProps = {
	onGetChosenComment: getChosenCommentAction,
	onSendComment: sendCommentAction,
	onResetForm: reset,
	onSetChosenComment: setChosenCommentAction,
};

const ChosenCommentModal = connect(mapStateToProps, mapDispatchToProps)(ChosenCommentModalWrapper);

ChosenCommentModalWrapper.propTypes = {
	onGetChosenComment: PropTypes.func.isRequired,
	onSendComment: PropTypes.func.isRequired,
	isFormSending: PropTypes.bool.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	onResetForm: PropTypes.func.isRequired,
	onSetChosenComment: PropTypes.func.isRequired,
	isChosenCommentLoading: PropTypes.bool.isRequired,
};

export default ChosenCommentModal;
